<div class="request-step-hint" *ngIf="!value">
	<span class="dot"></span> {{text | translate}}
</div>

<div class="request-step-hint" *ngIf="value" >
	<span class="dot"></span><span [translate]="text" [translateParams]="{'value': value}"></span>
</div>
